var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.334 5C34.2507 5 35.0361 5.32714 35.6895 5.98047C36.3427 6.63377 36.6691 7.41851 36.668 8.33398V26.667C36.668 27.5837 36.3417 28.3691 35.6895 29.0225C35.0372 29.6758 34.2517 30.0011 33.334 30H28.334L30.001 31.667V35H10.001V31.667L11.668 30H6.66797C5.75146 30 4.96661 29.6745 4.31445 29.0225C3.66223 28.3702 3.3351 27.5848 3.33398 26.667V8.33398C3.33398 7.41732 3.66112 6.63269 4.31445 5.98047C4.96776 5.32833 5.75247 5.00111 6.66797 5H33.334ZM6.66797 26.667H33.334V8.33398H6.66797V26.667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.6778cf131babd5ba4e6a0f162c596c1f.svg";
export { ForwardRef as ReactComponent };